import { render, staticRenderFns } from "./cookie-consent.vue?vue&type=template&id=35f335ad"
import script from "./cookie-consent.vue?vue&type=script&lang=js"
export * from "./cookie-consent.vue?vue&type=script&lang=js"
import style0 from "./cookie-consent.vue?vue&type=style&index=0&id=35f335ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports